export enum AiReviewConfigsTableFields {
  stepType = 'stepType',
  mode = 'mode',
  label = 'label',
  allowedActions = 'allowedActions',
  autoApproveMinSlpRate = 'autoApproveMinSlpRate',
  checks = 'checks',
  instructions = 'instructions',
  actions = 'actions',
}
